import React, { useEffect, useState } from "react";
import signinImg from "../../assets/images/signin-logo.png";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { useFormik } from "formik";
import { object, string } from "yup";
import axios from "axios";

let loginSchema = object({
  mobile_no: string().required("Mobile number is required"),
});

export function Forgot() {
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      mobile_no: "",
      user_type: "admin",
    },
    validationSchema: loginSchema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      setServerError("");

      const payload = {
        mobile_no: values.mobile_no.trim(),
        user_type: "admin",
      };

      console.log("👉 Payload before sending to API:", payload);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/forgot-password/`,
          payload
        );
        console.log("✅ Response from API:", response);

        if (response.data.status === "success") {
          const token = response.data.data.token;
          localStorage.setItem("otp_token", token);
          localStorage.setItem("mobile_no", values.mobile_no);
          navigate("/otp-screen");
        } else {
          setServerError(response.data.message || "failed");
        }
      } catch (error) {
        setServerError(
          error.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-left">
        <div>
          <div className="signin-logo">
            <img src={signinImg} />
          </div>
          <div className="signin-lefttext">
            Welcome to the Go Mak Admin Dashboard — your all-in-one platform for
            managing and optimizing medicine delivery operations. From tracking
            orders and monitoring delivery partners to ensuring security,
            reliability, and on-time service, this dashboard empowers you to
            streamline processes and provide healthcare providers with the
            medicines they need, when they need them.
          </div>
        </div>
      </div>
      <div className="signin-right">
        <div>
          <form className="signin-formContainer" onSubmit={formik.handleSubmit}>
            <div className="signin-title">Password Reset</div>
            {/* <div className="signin-subtitle">Password Reset</div> */}
            <div className="signin-field">
              <label>
                <span className="text-danger">*</span>Mobile Number
              </label>
              <div>
                <input
                  type="text"
                  placeholder="Enter mobile number"
                  maxLength={10}
                  name="mobile_no"
                  value={formik.values.mobile_no}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.mobile_no && formik.errors.mobile_no
                      ? "input-error-signIn"
                      : ""
                  }
                />
                {formik.touched.mobile_no && formik.errors.mobile_no && (
                  <div className="error-message-signIn">
                    {formik.errors.mobile_no}
                  </div>
                )}
              </div>
            </div>

            <div className="btnLogin">
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
            <div className="btnBack">
              <Link to="/">
                <button>Back</button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
